import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'alpaca-fee',
  action: ActionType.READ,
};
const updatePermission = {
  resource: 'alpaca-fee',
  action: ActionType.UPDATE,
};
const reportPermission = {
  resource: 'alpaca-fee-report',
  action: ActionType.READ,
};

export const AlpacaFee = {
  list: listPermission,
  update: updatePermission,
  report: reportPermission,
};
